import { Box, Typography, Grid, IconButton, Divider, Button, Link, useMediaQuery, useTheme } from "@mui/material";
import { Facebook, Twitter, YouTube, Instagram, LinkedIn } from "@mui/icons-material";
import logo from "../assets/aakash-logo-footer.png";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box sx={{ backgroundColor: "#333", color: "white", py: 4, px: 3 }}>
        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          <Grid container spacing={4} justifyContent={isMobile ? "center" : "space-between"}>
            <Grid item xs={12} sm={6} md={5} textAlign={isMobile ? "center" : "left"}>
              <img src={logo} alt="aakash-logo" style={{ width: 100 }} />
              <Box mt={2} display={'flex'} justifyContent={isMobile ? "center" : "flex-start"}>
                <Typography sx={{ fontWeight: 'bold', mr: 1 }}>Follow Us:</Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: -1 }}>
                  <IconButton sx={{ color: '#1877F2' }}><Facebook /></IconButton>
                  <IconButton sx={{ color: '#1DA1F2' }}><Twitter /></IconButton>
                  <IconButton sx={{ color: '#FF0000' }}><YouTube /></IconButton>
                  <IconButton sx={{ color: '#E4405F' }}><Instagram /></IconButton>
                  <IconButton sx={{ color: '#0A66C2' }}><LinkedIn /></IconButton>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4} textAlign={isMobile ? "center" : "left"}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#a0a0a0' }}>Aakash Educational Services Limited</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>Registered Office Address:</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>No. 5/2, 2nd Floor, Kundanahalli Gate, Varthur Road,<br /> Opposite SKR Kalyana Mandapa, Whitefield, Bengaluru 560037</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>CIN: U8030KA2007PLC150057</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>Telephone: +91-11–47623456</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>Fax: +91-11–47623472</Typography>
              <Typography variant="body2" sx={{ color: '#a0a0a0' }}>Email: corporate@aesl.in</Typography>
            </Grid>
          </Grid>

          {/* <Grid container spacing={4}>
            {[
              { title: "ABOUT US", links: ["About Aakash", "Aakash Nationwide Centers", "Why Aakash", "Aakash Methodology & Concept", "Aakash in Media", "Investor Corner"] },
              { title: "COURSES & SCHOLARSHIPS", links: ["Classroom Courses at Aakash", "Aakash Digital", "Aakash Distance Learning Program", "Aakash National Talent Hunt Exam (ANTHE)", "Admission Cum Scholarship Test (ACST)"] },
              { title: "NEET", links: ["NEET Exam", "NEET Exam Dates", "NEET Result", "NEET Cut Off", "NEET Syllabus", "NEET Counselling"] },
              { title: "JEE MAIN", links: ["JEE Main", "JEE Main College Predictor", "JEE Main Rank Predictor", "JEE Main Mock Tests", "JEE Main Answer Key Solutions", "JEE Main Syllabus"] },
              { title: "JEE ADVANCED", links: ["JEE Advanced", "JEE Advanced Syllabus", "JEE Advanced Eligibility Criteria", "JEE Advanced Results"] },
            ].map((section, index) => (
              <Grid item xs={6} md={2.4} key={index}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ color: '#a0a0a0',fontSize:14 }}>
                  {section.title}
                </Typography>
                {section.links.map((link, idx) => (
                  <Typography key={idx} variant="body2" sx={{ cursor: "pointer",fontSize:13, "&:hover": { textDecoration: "underline" } }}>
                    {link}
                  </Typography>
                ))}
              </Grid>

            ))}

          
            {[
              { title: "BOARD EXAMS", links: ["CBSE", "ICSE"] },
              { title: "NCERT", links: ["NCERT Solutions", "NCERT Solutions for Class 6", "NCERT Solutions for Class 7", "NCERT Solutions for Class 8"] },
              { title: "TEXT BOOK SOLUTIONS", links: ["Book Solutions", "RD Sharma Solutions", "RS Aggarwal Solutions", "HC Verma Solutions"] },
              { title: "OUR IMPORTANT CONCEPTS", links: ["Math Concepts", "Physics Concepts", "Biology Concepts", "Chemistry Concepts"] },
              { title: "STUDENT AREA", links: ["Aakash Results", "Aakash Answers", "Admission at Aakash", "ANTHE 2024"] },
            ].map((section, index) => (
              <Grid item xs={6} md={2.4} key={index}>
                <Divider sx={{ bgcolor: '#5b5b5b', mt: 1, mb: 1 }} />
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ color: '#a0a0a0',fontSize:14 }}>

                  {section.title}
                </Typography>
                {section.links.map((link, idx) => (
                  <Typography key={idx} variant="body2" sx={{ cursor: "pointer",fontSize:13, "&:hover": { textDecoration: "underline" } }}>
                    {link}
                  </Typography>
                ))}
              </Grid>
            ))}
          </Grid> */}
        </Box>

      </Box>
      <Divider sx={{ bgcolor: '#5b5b5b', height: 1.1 }} />
      <Box sx={{
        backgroundColor: "#333",
        color: "#bbb",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        textAlign: "center",
      }}>
        <Box sx={{ display: "flex", gap: 3, flexDirection: isMobile ? "column" : "row" }}>
          <Link href="#" underline="none" color="inherit" sx={{ fontSize: 14 }}>Terms & Conditions</Link>
          <Link href="#" underline="none" color="inherit" sx={{ fontSize: 14 }}>Disclaimer</Link>
          <Link href="#" underline="none" color="inherit" sx={{ fontSize: 14 }}>Privacy Policy</Link>
        </Box>
        <Typography variant="body2" sx={{ fontSize: 14, mt: isMobile ? 1 : 0 }}>
          © Aakash Institute Yelahanka
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
